import { render } from "./MenuPrevNext.vue?vue&type=template&id=90d51a54&scoped=true"
import script from "./MenuPrevNext.vue?vue&type=script&lang=js"
export * from "./MenuPrevNext.vue?vue&type=script&lang=js"

import "./MenuPrevNext.vue?vue&type=style&index=0&id=90d51a54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90d51a54"]])

export default __exports__